import { appConstants } from "../../constants/appconstants";
import { getApiCall, postApiCall } from "../../utils/ApiMethods";


const FetchContractDetailAction = (postData) => {
    return async function (dispatch) {
        // console.log(postData);
        // const postData = {
        //     "sectors": ["AMESA"],
        //       "business_units": ["India"],
        //       "categories": ["Co Man"],
        //       "startDate": "2024-06-01",
        //       "endDate": "2024-12-31"
        //     };
        const data = await postApiCall(`${appConstants.BASE_URL}/contract-management/kpi-page-data`, postData);
        var resData = Object.assign({ type: 'SUCCESS_CONTRACT_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchArchletDetailAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/archlet/kpi-page-details`, postData);
        var resData = Object.assign({ type: 'SUCCESS_ARCHLET_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchArchletDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/archlet/drop-down-filter-details`, postData);
        var resData = Object.assign({ type: 'SUCCESS_ARCHLET_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchAribaDropdownAction = (postData) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/ariba-sourcing/dropdown-filters`, postData);
        var resData = Object.assign({ type: 'SUCCESS_ARIBA_DROPDOWN_ACTION' }, data);
        dispatch(resData);
    };
};

const FetchAribaKpiAction = (requestObj) => {
    return async function (dispatch) {
        const data = await postApiCall(`${appConstants.BASE_URL}/ariba-sourcing/kpi-page-data`, requestObj)
        var resData = Object.assign({ type: 'SUCCESS_ARIBA_DETAIL_VIEW_ACTION' }, data);
        dispatch(resData);
    }
}


export {
    FetchContractDetailAction,
    FetchArchletDetailAction,
    FetchArchletDropdownAction,
    FetchAribaDropdownAction,
    FetchAribaKpiAction
}